import type { AllMarkets, AllMarketsContent } from '../blocks/all-markets'
import type { Asset } from '../shared'
import type { StoryblokContent } from '~/types/storyblok'
import type { Story } from '~/types/vendors/storyblok'
import type Storyblok from '~/types/vendors/storyblok'
import { normalizeAllMarkets } from '../blocks/all-markets'

export interface PdpShippingMessageContent extends StoryblokContent {
  id: Storyblok.Text
  component: 'pdp-shipping-message'
  text: AllMarketsContent[]
  icon: Asset
  text_color: string
}

export interface PdpShippingMessage {
  text: AllMarkets
  iconUrl?: string
  iconAlt?: string
  textColor: string
}

export function normalizePdpShippingMessage(
  story?: Story<PdpShippingMessageContent>,
): PdpShippingMessage | undefined {
  const { content } = story ?? {}

  if (!content)
    return

  const allMarketsText = content.text[0]

  if (!allMarketsText)
    return

  return {
    text: normalizeAllMarkets(allMarketsText),
    iconUrl: content.icon?.filename,
    iconAlt: content.icon ? (content.icon?.alt || '') : undefined,
    textColor: content.text_color || 'black',
  }
}
